import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "h-screen w-full" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "debugger__grid-size" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")!
  const _component_Grid = _resolveComponent("Grid")!

  return (_ctx.showGrid)
    ? (_openBlock(), _createBlock(_component_Grid, {
        key: 0,
        class: "debugger pointer-events-none w-screen h-screen fixed left-0 top-0 right-0"
      }, {
        default: _withCtx(({ columns }) => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(columns, (index) => {
            return (_openBlock(), _createBlock(_component_Column, {
              key: index,
              span: 1,
              class: "debugger__column"
            }, {
              default: _withCtx(() => [
                _hoisted_1
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _hoisted_2
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}